import React from 'react';
import './ContentContainer.css';
import { Tabs } from './tabs/Tabs';

export const ContentContainer = () => {
    return (
        <div className='content-container'>
            <Tabs />
        </div>
    )
};


// WEBPACK FOOTER //
// ./src/components/content-container/ContentContainer.jsx